import { Button, Form, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { showNotificationWithIcon } from "../../../utils/helpers/helpers";
import { getUserInfo } from "../../../utils/redux/reducers/User";
import { Locale } from "../../../utils";
import { getVipList, transferToVip } from "../qrcodes/qrcodeApi";
import { getMerchantSettings } from "../../../utils/redux/reducers/Merchant";

const i18n = Locale.getInstance();

const TYPE_BOX = 2;

const TransferToVipModal = ({ visible, item, onCancel, onSuccess }) => {
  const user = useSelector((state) => getUserInfo(state));
  const settings = useSelector((state) => getMerchantSettings(state));
  const [form] = Form.useForm();
  const [vipSearch, setVipSearch] = useState("");
  const [vipPage, setVipPage] = useState(1);

  if (!settings.enable_lottery_qrcode_transfer) return;

  const merchantId = user?.merchant?.id;
  const { data: vipData, isLoading: vipLoading } = useQuery(
    ["merchant-vips", user.token, merchantId, vipSearch, vipPage],
    () =>
      getVipList({
        token: user.token,
        merchant_id: merchantId,
        page: vipPage,
        limit: 20,
        keyword: vipSearch || undefined,
      }),
    { enabled: !!merchantId && visible }
  );

  const transferMutation = useMutation(
    ({ item_id, vip_user_id, token }) =>
      transferToVip({ item_id, vip_user_id, token }),
    {
      onSuccess: (response) => {
        const count =
          response?.data?.product_count ?? response?.product_count ?? 0;
        showNotificationWithIcon(
          i18n.t("qrcode.transferToVipSuccess", { count }),
          "success"
        );
        form.resetFields();
        onSuccess?.();
        onCancel?.();
      },
      onError: (error) => {
        const message =
          error?.message ||
          error?.data?.message ||
          i18n.t("qrcode.transferToVipError");
        showNotificationWithIcon(message, "error");
      },
    }
  );

  const handleSubmit = (values) => {
    const item_id = item?.secure_code ?? item?.code;
    if (!item_id) {
      showNotificationWithIcon(i18n.t("qrcode.transferBoxCodeRequired"), "error");
      return;
    }
    transferMutation.mutate({
      item_id: String(item_id).trim(),
      vip_user_id: values.vip_user_id,
      token: user.token,
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  const vips = vipData?.data && vipData.data.users && vipData.data.users.data ? vipData.data.users.data : [];
  const vipOptions = vips?.map((v) => ({
    value: v.user_id ?? v.id,
    label:
      v.nickname + ' - ' +
      v.mobile

  }));

  const isBox = item?.type === TYPE_BOX;

  return (
    <Modal
      title={i18n.t("qrcode.transferToVip")}
      open={visible && isBox}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      {item && (
        <p style={{ marginBottom: 16, color: "rgba(0,0,0,0.65)" }}>
          {i18n.t("qrcode.itemCode")}: {item.code ?? "—"}
        </p>
      )}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ vip_user_id: undefined }}
      >
        <Form.Item
          name="vip_user_id"
          label={i18n.t("qrcode.transferSelectVip")}
          rules={[
            {
              required: true,
              message: i18n.t("qrcode.transferSelectVipRequired"),
            },
          ]}
        >
          <Select
            showSearch
            placeholder={i18n.t("qrcode.transferSelectVipPlaceholder")}
            filterOption={false}
            onSearch={setVipSearch}
            notFoundContent={vipLoading ? <Spin size="small" /> : null}
            options={vipOptions}
            loading={vipLoading}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={transferMutation.isLoading}
            disabled={transferMutation.isLoading}
          >
            {i18n.t("qrcode.transferSubmit")}
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
            {i18n.t("common.cancelText")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TransferToVipModal;
